export default __webpack_public_path__ + "TUBE-CENTER.jpg";